"use client"
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'

import _live_price_card from './live-price-card.bones.json'

registerBones({
  "live-price-card": _live_price_card,
})
